import { AuthStateType } from "../../UserReducer";
import { useAuthState } from "./useAuthState";

const createSelectorHook = () => {

    function useSelector<T>(callback: (state: AuthStateType) => T) {
        const state = useAuthState();
        return callback(state)
    }
    
    return useSelector;
  };

export const useSelector = createSelectorHook();